var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargingstation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 88,
    viewBox: "0 0 72 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.95 36.1026C71.95 51.6467 62.73 60.9431 53.1 70.6307C47.28 76.2867 41.67 82.1434 36.05 88C30.44 82.1434 24.82 76.2867 19 70.6307C9.38 60.9431 0 51.6467 0 36.1026C-1.99253e-07 31.3615 0.931187 26.6669 2.74036 22.2867C4.54953 17.9066 7.20125 13.9266 10.5442 10.5742C13.8871 7.22177 17.8557 4.56247 22.2234 2.74815C26.5911 0.933825 31.2724 0 36 0C40.7276 0 45.4089 0.933825 49.7766 2.74815C54.1443 4.56247 58.113 7.22177 61.4559 10.5742C64.7988 13.9266 67.4505 17.9066 69.2597 22.2867C71.0688 26.6669 72 31.3615 72 36.1026H71.95Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 34,
    fill: "#0C3A7E",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8973 33.0657L34.6554 53.8867C34.5064 54.2471 34.134 54.3913 33.8364 54.3913C33.315 54.3913 32.7942 53.9591 32.9432 53.3827L35.0278 40.7029C35.1021 40.1983 34.6554 39.6943 34.1346 39.6943H26.9129C26.243 39.6943 25.7963 38.9736 26.0939 38.3977L37.3358 17.5046C37.4848 17.1442 37.7824 17 38.1547 17C38.6761 17 39.197 17.4322 39.048 18.0086L36.9634 30.6884C36.8891 31.193 37.3357 31.6971 37.8566 31.6971H45.0783C45.823 31.7684 46.1948 32.4891 45.8973 33.0655V33.0657Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingstation);
export default __webpack_public_path__ + "static/media/chargingstation.c5ab650d80ae12b522fb25a0d03de5c4.svg";
export { ForwardRef as ReactComponent };